/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";

const navigation = [
  { name: "Explore", href: "#", current: true },
  { name: "Artwork", href: "#", current: false },
  { name: "How to Buy", href: "#", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar() {
  return (
    <Disclosure
      as="nav"
      className="bg-[#fff] lg:bg-transparent w-full lg:mt-4 cursor-normal fixed lg:absolute top:0 left-0 z-50"
    >
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 right-0 flex items-center lg:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="w-12 h-12 inline-flex items-center justify-center p-2 rounded-full text-gray-400 bg-[#fff] focus:outline-none drop-shadow-2xl hover:scale-125 ease-in-out duration-300">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch lg:justify-start gap-8">
                <div className="flex-shrink-0 flex items-center">
                  <svg
                    className="h-8 fill-[#000]"
                    viewBox="0 0 98 33"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="current-color"
                  >
                    <path
                      clip-rule="evenodd"
                      d="M64.894 16.456c0 9.088-7.368 16.456-16.457 16.456s-16.455-7.368-16.455-16.456S39.349 0 48.438 0s16.455 7.368 16.455 16.456zM16.902 1.567a.784.784 0 0 1 1.358 0L35.056 30.66a.784.784 0 0 1-.679 1.176H.785a.784.784 0 0 1-.679-1.176zM68.614.98c-.865 0-1.567.702-1.567 1.568v27.818c0 .866.702 1.567 1.567 1.567h27.819c.865 0 1.567-.701 1.567-1.567V2.547c0-.866-.702-1.568-1.567-1.568z"
                    ></path>
                  </svg>
                </div>
                <div className="hidden lg:flex grow items-center sm:static">
                  <label class="relative block w-full">
                    <span class="sr-only">Search</span>
                    <span class="absolute inset-y-0 left-0 flex items-center pl-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 stroke-[#999] focus:stroke-[#000]"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </span>
                    <input
                      placeholder="Search Foundation.."
                      type="search"
                      name="search"
                      class="placeholder:text-[#999] block bg-white w-full border border-[#fff]/[.4] rounded-full py-3 pl-12 pr-5 shadow-sm focus:outline-none focus:ring-[#000] focus:ring-1 text-base font-normal"
                    />
                  </label>
                </div>
                <div className="hidden lg:block sm:ml-auto">
                  <div className="flex space-x-2">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current ? "text-[#666666]" : "text-[#666666]",
                          "px-3 py-2 rounded-md text-sm font-semibold text-base flex items-center"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                    <button
                      type="button"
                      className="bg-[#000] rounded-full text-[#fff] capitalize px-5 py-3"
                    >
                      connect wallet
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="lg:hidden">
            <div
              className="flex flex-col justify-between gap-5 px-2 pt-2 pb-3"
              style={{ minHeight: "calc(100vh - 64px)" }}
            >
              <div className="">
                <label class="relative block w-full  drop-shadow-md">
                  <span class="sr-only">Search</span>
                  <span class="absolute inset-y-0 left-0 flex items-center pl-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 stroke-[#999] focus:stroke-[#000]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </span>
                  <input
                    placeholder="Search Foundation..."
                    type="search"
                    name="search"
                    class="placeholder:text-[#999] block bg-white w-full border border-[#fff]/[.4] rounded-full py-3 pl-12 pr-5 focus:outline-none focus:ring-[#000] focus:ring-1 text-base font-normal"
                  />
                </label>
              </div>
              <div>
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.href}
                    className={classNames(
                      item.current ? "text-[#000]" : "text-[#000]",
                      "px-3 py-2 rounded-md font-semibold text-3xl block"
                    )}
                    aria-current={item.current ? "page" : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
              <div className="mt-auto px-2">
                <button
                  type="button"
                  className="bg-[#000] rounded-full text-[#fff] capitalize px-5 py-3 w-full mb-5"
                >
                  connect wallet
                </button>
                <div className="grid sm:grid-cols-2 font-normal text-[#666666] capitalize gap-x-4 gap-y-2">
                  <a href="#">press</a>
                  <a href="#">Community Guidelines</a>
                  <a href="#">Terms of Service</a>
                  <a href="#">Privacy</a>
                </div>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export default Navbar;
